import { put, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import createRequest from '../../../utils/axios';
import * as actionTypes from './selfDiagnosisActionTypes';
import selfDiagnosisReducer from './selfDiagnosisReducer';

export function* getSymptoms(action) {
  /* const user = yield select((state) => state.homeReducer.user); */
  const Axios = yield createRequest();
  try {
    const { data } = yield Axios.get(`symptom`);
    console.log(data);
    yield put({
      type: actionTypes.GET_SYMPTOMS_SUCCESS,
      data,
    });
  } catch (error) {
    console.log(error);
    toast.error(error.response.data.message);
    yield put({
      type: actionTypes.GET_SYMPTOMS_FAILED,
    });
  }
}

export function* diagnoseDisease(action) {
  const stepOneSelectedDiseases = yield select(
    (state) => state.selfDiagnosisReducer.stepOneSelectedDiseases
  );
  const Axios = yield createRequest();
  try {
    const { data } = yield Axios.post(`symptom/disease`, {
      symptoms: stepOneSelectedDiseases.map((el) => el._id),
    });
    if (data.result.shouldCheck) {
      yield put({
        type: actionTypes.DIAGNOSE_DISEASE_SUCCESS_GOTO_STEP_TWO,
        data: data.result,
      });
      yield put({
        type: actionTypes.SET_ACTIVE_STATE,
        data: 1,
      });
    } else {
      yield put({
        type: actionTypes.DIAGNOSE_DISEASE_SUCCESS_WITH_RESULTS,
        data: data.result,
      });
      yield put({
        type: actionTypes.SET_ACTIVE_STATE,
        data: 2,
      });
    }
  } catch (error) {
    console.log(error.response);
    toast.error(error.response.data.message);
    yield put({
      type: actionTypes.DIAGNOSE_DISEASE_FAILED,
    });
  }
}
